import React, { useState, useEffect, use } from "react"
import {
  Typography,
  Space,
  Button,
  Tabs,
  Card,
  Tag,
  Tooltip,
  Dropdown,
  Menu,
  Badge,
  Divider,
  Skeleton,
  Row,
  Col,
  Empty,
  Descriptions,
  Layout,
  Avatar,
  message
} from "antd"
import {

  DownloadOutlined,
  MailOutlined,
  PhoneOutlined,
  LeftOutlined,
  RightOutlined,

  UserOutlined,
  FileTextOutlined,

  EnvironmentOutlined,
  CalendarOutlined,

  EyeOutlined,
  EditOutlined,
  BankOutlined,
  BookOutlined
} from "@ant-design/icons"
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer"
import moment from "moment"
import { useCandidateDetails } from "../hooks/useCandidateDetails"
import Notes from "../../../Modals/Notes"
import { CANDIDATE_NOTE_UPDATE, CANDIDATE_NOTE_DELETE, CANDIDATE_UPDATE_PARTIALLY } from "../../../../../ApiUrl"
import { useSelector } from "react-redux"
import cssStyles from './CB.module.css'
import { useNotes } from '../context/notesContext';
import axios from 'axios' // Import axios
import { requestHeader } from "../../../../../others/header"

const { Text, Title } = Typography
const { TabPane } = Tabs
const { Content } = Layout


const styles = {
  container: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    backgroundColor: "#f5f7fa",
  },
  header: {
    padding: "12px 24px",
    borderBottom: "1px solid #f0f0f0",
    backgroundColor: "#fff",
    zIndex: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  content: {
    flex: 1,
    overflow: "auto",
    padding: "24px",
    backgroundColor: "#f5f7fa"
  },
  section: {
    marginBottom: "24px",
  },
  navigationButton: {
    color: "#52c41a",
    border: "none",
    background: "transparent",
    fontSize: "16px"
  },
  matchScore: {
    marginRight: 16,
    backgroundColor: "#f6ffed",
    border: "1px solid #b7eb8f",
    color: "#52c41a",
    padding: "2px 10px",
    borderRadius: "12px",
    fontSize: "12px",
    fontWeight: "bold",
  },
  avatar: {
    width: 120,
    height: 120,
    marginBottom: 16,
    backgroundColor: '#f6ffed',
    color: '#52c41a',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '48px',
    borderRadius: '50%'
  },
  sectionTitle: {
    marginBottom: '12px',
    borderBottom: '1px solid #f0f0f0',
    paddingBottom: '8px',
    color: '#52c41a'
  },
  card: {
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
    marginBottom: '16px'
  },
  workHistoryCard: {
    marginBottom: '16px',
    borderLeft: '3px solid #52c41a',
    boxShadow: '0 2px 8px rgba(0,0,0,0.09)'
  },
  educationCard: {
    marginBottom: '16px',
    borderLeft: '3px solid #52c41a',
    boxShadow: '0 2px 8px rgba(0,0,0,0.09)'
  },
  summaryCard: {
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    borderLeft: '4px solid #52c41a',
    maxHeight: '300px',
    overflow: 'auto'
  },
  iconStyle: {
    color: '#52c41a',
    marginRight: '8px',
    fontSize: '16px'
  },
  bulletPoint: {
    color: '#52c41a',
    marginRight: '8px',
    fontSize: '16px',
    marginTop: '2px'
  },
  tabsStyle: {
    backgroundColor: '#fff',
    padding: '16px',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.09)'
  },
  viewedTag: {
    backgroundColor: '#f6ffed',
    borderColor: '#b7eb8f',
    color: '#52c41a',
    marginLeft: '8px',
    fontSize: '12px'
  },
  headerControls: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  basicInfoContainer: {
    padding: '24px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    marginBottom: '24px'
  },
  contactInfoItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px'
  },
  candidateName: {
    fontSize: '24px',
    marginBottom: '4px',
    fontWeight: 'bold',
    color: '#333'
  },
  candidateTitle: {
    color: '#555',
    marginBottom: '16px',
    fontSize: '16px'
  },
  tabsContainer: {
    marginTop: '16px',
    borderBottom: '1px solid #f0f0f0'
  }
}


const getFieldValue = (data, fieldName) => {
  if (!data) return null;


  if (data[fieldName] !== undefined) {
    return data[fieldName];
  }


  if (data[fieldName] && Array.isArray(data[fieldName]) && data[fieldName][0] !== undefined) {
    return data[fieldName][0];
  }

  return null;
};

// Process location data in either format
const processLocation = (locationData) => {
  if (!locationData) return 'Not specified';

  if (locationData.HomeLocation && Array.isArray(locationData.HomeLocation) && locationData.HomeLocation[0]) {
    const location = locationData.HomeLocation[0];
    const parts = [];
    if (location.City) parts.push(location.City);
    if (location.State) parts.push(location.State);
    if (location.Country) parts.push(location.Country);
    return parts.join(', ');
  }


  if (locationData.locationDetails) {
    const location = locationData.locationDetails;
    const parts = [];
    if (location.cityName) parts.push(location.cityName);
    if (location.stateName) parts.push(location.stateName);
    if (location.countryName) parts.push(location.countryName);
    return parts.join(', ');
  }

  if (locationData.location) {
    return locationData.location;
  }

  return 'Not specified';
};

const CandidateActions = ({ onAction, isInDb, isCompared }) => {
  const actionItems = [

    {
      key: "download",
      icon: <DownloadOutlined />,
      label: "Download Resume"
    },
  ]

  return (
    <Space>
      {actionItems.map(({ key, icon, label, disabled }) => (
        <Tooltip key={key} title={label}>
          <Button
            icon={icon}
            onClick={() => onAction(key)}
            type={(key === "compare" && isCompared) ? "primary" : "default"}
            style={(key === "compare" && isCompared) ? { backgroundColor: '#52c41a', borderColor: '#52c41a', color: '#fff' } : {}}
            disabled={disabled}
          />
        </Tooltip>
      ))}
    </Space>
  )
}

const NavigationButtons = ({ onPrevious, onNext, hasPrevious, hasNext }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    <Button
      type="text"
      icon={<LeftOutlined />}
      onClick={onPrevious}
      disabled={!hasPrevious}
      style={styles.navigationButton}
    />
    <Button
      type="text"
      icon={<RightOutlined />}
      onClick={onNext}
      disabled={!hasNext}
      style={styles.navigationButton}
    />
  </div>
)


const ProfileSection = ({ title, children }) => (
  <div style={{ marginBottom: '24px' }}>
    <Title level={5} style={styles.sectionTitle}>
      {title}
    </Title>
    <div style={{ paddingLeft: '8px' }}>{children}</div>
  </div>
);


const WorkHistoryItem = ({ company, title, tenure }) => (
  <Card
    size="small"
    style={styles.workHistoryCard}
  >
    <div style={{ padding: '8px' }}>
      <Text strong style={{ fontSize: '16px', display: 'block' }}>{title}</Text>
      <Text style={{ display: 'block', color: '#555' }}>{company}</Text>
      <Text type="secondary">{tenure}</Text>
    </div>
  </Card>
);


const EducationItem = ({ school, major, degree, graduationDate }) => (
  <Card
    size="small"
    style={styles.educationCard}
  >
    <div style={{ padding: '8px' }}>
      <Text strong style={{ fontSize: '16px', display: 'block' }}>{school}</Text>
      {degree && <Text style={{ display: 'block', color: '#555' }}>{degree} {major ? `in ${major}` : ''}</Text>}
      {graduationDate && <Text type="secondary">{graduationDate}</Text>}
    </div>
  </Card>
);

const CandidateDetailView = ({
  candidate,
  onNext,
  onPrevious,
  hasNext,
  hasPrevious,
  onAction,
  isInDb,
  isCompared,
  onBack
}) => {
  const { fetchDetails, detailsCache, loading, error } = useCandidateDetails()
  const [activeTab, setActiveTab] = useState("profile")
  const [showNotes, setShowNotes] = useState(false)
  const [selectedRow, setSelectedRow] = useState(null)
  const [candidateDbId, setCandidateDbId] = useState(null)
  const [notesData, setNotesData] = useState({ data: { data: { multipleNotes: [] } }, success: true })

  const { syncNotes, addNote, updateNote, deleteNote, getCandidateNotes, getLastUpdated, syncCandidateDbId } = useNotes();

  const updateCandidateNote = async (value, id) => {
    try {
      const response = await axios.patch(`${CANDIDATE_NOTE_UPDATE}/${candidateDbId}/${id}`, value, requestHeader());
      return response.data;
    } catch (error) {
      console.error("Error updating note:", error);
      throw error;
    }
  };

  const deleteCandidateNote = async (id) => {
    try {
      const response = await axios.delete(`${CANDIDATE_NOTE_DELETE}/${candidateDbId}/${id}`, requestHeader());
      return response.data;
    } catch (error) {
      console.error("Error deleting note:", error);
      throw error;
    }
  };

  const updateCandidatePartially = async (data, id = candidateDbId) => {
    try {
      const response = await axios.patch(`${CANDIDATE_UPDATE_PARTIALLY}/${id}`, data, requestHeader());
      return response.data;
    } catch (error) {
      console.error("Error updating candidate:", error);
      throw error;
    }
  };

  const users = useSelector(({ users }) => users)

  const sid = candidate?.id
  const currentError = sid ? error[sid] : null

  const isLoading = loading[sid] || false


  const currentDetails = sid ? detailsCache[sid]?.data : null

  const [isViewed, setIsViewed] = useState(candidate?.isViewed || false);

  useEffect(() => {
    if (sid && detailsCache[sid]) {

      const candidateId = detailsCache[sid].candidateId ||
        (detailsCache[sid].data && detailsCache[sid].data.candidateId) ||
        (detailsCache[sid].data && detailsCache[sid].data._id) ||
        null;


      setCandidateDbId(candidateId);
      syncCandidateDbId(sid, candidateDbId);


      if (detailsCache[sid].data) {
        let notes = null;


        if (detailsCache[sid].data.notes && Array.isArray(detailsCache[sid].data.notes)) {
          notes = detailsCache[sid].data.notes;
        } else if (detailsCache[sid].data.multipleNotes && Array.isArray(detailsCache[sid].data.multipleNotes)) {
          notes = detailsCache[sid].data.multipleNotes;
        }

        if (notes && Array.isArray(notes)) {

          setNotesData({
            data: {
              data: {
                multipleNotes: notes
              }
            },
            success: true
          });

          setTimeout(() => {
            syncNotes(sid, notes);
          }, 100);
        }
      }


      setSelectedRow({
        _id: candidateId,
        ...currentDetails
      });
    }

  }, [sid, detailsCache, currentDetails]);

  const [lastSyncTime, setLastSyncTime] = useState(0);


  useEffect(() => {
    if (!sid) return;

    const lastUpdateTime = getLastUpdated(sid);

    if (lastUpdateTime > lastSyncTime) {
      const contextNotes = getCandidateNotes(sid);

      setNotesData({
        data: {
          data: {
            multipleNotes: contextNotes
          }
        },
        success: true
      });

      if (contextNotes.length === 0) {
        setShowNotes(false);
      }

      setLastSyncTime(Date.now());
    }
  }, [sid, getCandidateNotes, getLastUpdated, lastSyncTime]);

  useEffect(() => {
    if (sid) {
      fetchDetails(candidate)
        .then(details => {
          if (details?.candidateId) {
            setCandidateDbId(details.candidateId);
            syncCandidateDbId(sid, details.candidateId);

          }
        })
        .catch((err) => console.error("Error fetching candidate details:", err))
    }
  }, [sid, fetchDetails, candidate])

  useEffect(() => {
    if (activeTab === "notes" && candidateDbId) {
      setShowNotes(true);
    }
  }, [activeTab, candidateDbId])

  useEffect(() => {
    if (sid && !isViewed) {
      setIsViewed(true);

      if (candidateDbId) {
        console.log("Marking candidate as viewed:", candidateDbId);
        updateCandidatePartially({
          id: candidateDbId,
          isViewed: true,
          viewHistory: [...(candidate.viewHistory || []), {
            viewedAt: new Date().toISOString(),
            viewedBy: users.user?.id || 'unknown'
          }]
        })
          .then(() => {
            console.log("Successfully marked candidate as viewed");
          })
          .catch(err => {
            console.error("Error marking candidate as viewed:", err);
          });
      }
    }
  }, [sid, candidateDbId, isViewed, candidate.viewHistory, users.user]);

  const handleAction = (action) => {
    if (action === "download") {
      // Handle resume download
      if (currentDetails) {
        const isV1Format = currentDetails && currentDetails.ContactName;

        if (isV1Format) {
          // Check if we have a PDF (base64 encoded)
          if (currentDetails.ResumeHTML?.[0]?.startsWith('JVBERi0')) {
            // This is a base64 encoded PDF - create download link
            const pdfData = currentDetails.ResumeHTML[0];
            const pdfUrl = `data:application/pdf;base64,${pdfData}`;

            // Create a temporary link element and trigger download
            const downloadLink = document.createElement('a');
            downloadLink.href = pdfUrl;
            downloadLink.download = `${currentDetails.ContactName?.[0] || 'resume'}.pdf`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);

            message.success('Resume downloaded successfully');
            return;
          }

          // If it's HTML content, convert to a downloadable format
          if (currentDetails.ResumeHTML?.[0]) {
            const cleanHtml = currentDetails.ResumeHTML[0]
              .replace(/&lt;/g, '<')
              .replace(/&gt;/g, '>')
              .replace(/&amp;/g, '&')
              .replace(/&quot;/g, '"')
              .replace(/&#39;/g, "'")
              .replace(/&nbsp;/g, ' ');

            // Create a blob with the HTML content
            const htmlBlob = new Blob([`
              <!DOCTYPE html>
              <html>
                <head>
                  <title>Resume</title>
                  <style>
                    body { font-family: Arial, sans-serif; line-height: 1.6; padding: 20px; }
                    .resume-content div { position: static !important; margin-bottom: 8px; }
                  </style>
                </head>
                <body>
                  ${cleanHtml}
                </body>
              </html>
            `], { type: 'text/html' });

            // Create download link
            const url = URL.createObjectURL(htmlBlob);
            const downloadLink = document.createElement('a');
            downloadLink.href = url;
            downloadLink.download = `${currentDetails.ContactName?.[0] || 'resume'}.html`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            URL.revokeObjectURL(url);

            message.success('Resume downloaded successfully');
            return;
          }

          // Fallback to text content
          if (currentDetails.ResumeText?.[0]) {
            // Create a blob with the text content
            const textBlob = new Blob([currentDetails.ResumeText[0]], { type: 'text/plain' });

            // Create download link
            const url = URL.createObjectURL(textBlob);
            const downloadLink = document.createElement('a');
            downloadLink.href = url;
            downloadLink.download = `${currentDetails.ContactName?.[0] || 'resume'}.txt`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            URL.revokeObjectURL(url);

            message.success('Resume downloaded successfully');
            return;
          }
        } else if (currentDetails?.attachments) {
          // V2 format - direct download from URL
          const resumeUrl = `${process.env.REACT_APP_CANDIDATE_RESUME_URL}${currentDetails.attachments}`;
          window.open(resumeUrl, '_blank');
          message.success('Resume download initiated');
          return;
        }
      }

      message.error('Resume not available for download');
    } else {
      // For other actions like "compare", pass to parent component
      onAction(action, candidate.id);
    }
  }


  const handleNotes = async (value) => {
    if (candidateDbId) {
      try {
        const noteWithUser = {
          ...value,
          created_by: {
            _id: users.user?._id || 'unknown',
            display_name: users.user?.display_name || 'Unknown User'
          },
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
          updated_by: {
            _id: users.user?._id || 'unknown',
            display_name: users.user?.display_name || 'Unknown User'
          }
        };

        const response = await updateCandidatePartially({
          multipleNotes: noteWithUser
        });

        const newNoteWithId = {
          ...noteWithUser,
          _id: response?.data?.multipleNotes?.[0]?._id
        };


        // Get current notes and add the new one
        const currentNotes = notesData?.data?.data?.multipleNotes || [];
        const updatedNotes = [...currentNotes, newNoteWithId];

        setNotesData({
          data: {
            data: {
              multipleNotes: updatedNotes
            }
          },
          success: true
        });

        setTimeout(() => {
          syncNotes(sid, updatedNotes);
        }, 100);

        // Update currentDetails to stay in sync
        if (currentDetails) {
          currentDetails.multipleNotes = updatedNotes;
        }

        message.success("Note added successfully");

      } catch (err) {
        console.error("Error adding note:", err);
        message.error("Failed to add note");
      }
    } else {
      message.warning("Cannot add notes: Candidate not found in database");
    }
  };
  useEffect(() => {
    if (sid) {
      const contextNotes = getCandidateNotes(sid)
    }
  }, [sid, getCandidateNotes, notesData]);



  const handleUpdateNotes = (value, id) => {
    if (candidateDbId) {

      const noteUpdate = {
        ...value,
        updated_at: new Date().toISOString(),
        updated_by: {
          _id: users.user?._id || 'unknown',
          display_name: users.user?.display_name || 'Unknown User'
        }
      };

      updateCandidateNote(noteUpdate, id)
        .then(response => {
          message.success("Notes updated successfully");


          const currentNotes = notesData?.data?.data?.multipleNotes || [];
          const updatedNotes = currentNotes.map(note =>
            note._id === id ? { ...note, ...noteUpdate } : note
          );


          setNotesData({
            data: {
              data: {
                multipleNotes: updatedNotes
              }
            },
            success: true
          });


          setTimeout(() => {
            syncNotes(sid, updatedNotes);
          }, 100);


          if (currentDetails) {
            currentDetails.multipleNotes = updatedNotes;
          }
        })
        .catch(err => {
          console.error("Error updating notes:", err);
          message.error("Failed to update notes");
        });
    } else {
      message.warning("Cannot update notes: Candidate not found in database");
    }
  };

  const handleDeleteNotes = (id) => {
    if (candidateDbId) {
      deleteCandidateNote(id)
        .then(response => {
          message.success("Notes deleted successfully");


          const updatedNotes = response?.data?.multipleNotes ||
            response?.data?.data?.multipleNotes ||
            currentDetails.multipleNotes.filter(note => note._id !== id);


          deleteNote(sid, id);


          setNotesData({
            data: {
              data: {
                multipleNotes: updatedNotes
              }
            },
            success: true
          });


          setTimeout(() => {
            syncNotes(sid, updatedNotes);
          }, 150);

          if (currentDetails) {
            currentDetails.multipleNotes = updatedNotes;
          }
        })
        .catch(err => {
          console.error("Error deleting notes:", err);
          message.error("Failed to delete notes");
        });
    } else {
      message.warning("Cannot delete notes: Candidate not found in database");
    }
  };
  useEffect(() => {
    if (sid) {
      const contextNotes = getCandidateNotes(sid)
    }
  }, [sid, getCandidateNotes, notesData]);
  const renderLocation = (locationDetails) => {
    if (!currentDetails) return candidate.location;


    if (currentDetails.HomeLocation && Array.isArray(currentDetails.HomeLocation) && currentDetails.HomeLocation[0]) {
      const location = currentDetails.HomeLocation[0];
      const parts = [];
      if (location.City) parts.push(location.City);
      if (location.State) parts.push(location.State);
      if (location.Country) parts.push(location.Country);
      return parts.join(', ');
    }


    if (locationDetails && typeof locationDetails === 'object') {
      const parts = [];
      if (locationDetails.cityName) parts.push(locationDetails.cityName);
      if (locationDetails.stateName) parts.push(locationDetails.stateName);
      if (locationDetails.countryName) parts.push(locationDetails.countryName);
      if (locationDetails.postalCode) parts.push(locationDetails.postalCode);
      return parts.join(', ');
    }


    return candidate.location;
  };

  const renderHeader = () => {
    // Check if we have v1 format data
    const isV1Format = currentDetails && currentDetails.ContactName;

    // Get name (try different formats)
    const name = isV1Format
      ? currentDetails?.ContactName?.[0]
      : (currentDetails?.first_name
        ? `${currentDetails.first_name} ${currentDetails.last_name}`
        : candidate.name);

    return (
      <div style={styles.header}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Button
            type="text"
            icon={<LeftOutlined />}
            onClick={onBack}
            style={{ color: '#52c41a', marginRight: '8px' }}
          >
            Back to Results
          </Button>
          <Title level={4} style={{ margin: 0 }}>
            {name || "Confidential Candidate"}
          </Title>
          {isViewed && (
            <Tag icon={<EyeOutlined />} style={styles.viewedTag}>
              Viewed
            </Tag>
          )}
        </div>
        <div style={styles.headerControls}>
          <NavigationButtons onPrevious={onPrevious} onNext={onNext} hasPrevious={hasPrevious} hasNext={hasNext} />

          <CandidateActions onAction={handleAction} isInDb={isInDb} isCompared={isCompared} />
        </div>
      </div>
    );
  };

  const renderBasicInfo = () => {
    // Check if we have v1 format data
    const isV1Format = currentDetails && currentDetails.ContactName;

    // Get name (try different formats)
    const name = isV1Format
      ? currentDetails.ContactName?.[0]
      : (currentDetails?.first_name
        ? `${currentDetails.first_name} ${currentDetails.last_name}`
        : candidate.name);

    // Get job title (try different formats)
    const jobTitle = isV1Format
      ? currentDetails.ResumeTitle?.[0]
      : (currentDetails?.desired_job_type || candidate.currentPosition?.title);

    // Get contact info
    const email = isV1Format
      ? currentDetails.ContactEmail?.[0]
      : currentDetails?.email;

    const phone = isV1Format
      ? currentDetails.ContactPhone?.[0]
      : currentDetails?.mobile;

    const location = renderLocation(candidate.locationDetails);

    return (
      <div style={styles.basicInfoContainer}>
        <Row gutter={24} align="top">
          <Col xs={24} sm={6} style={{ textAlign: 'center' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={styles.avatar}>
                <UserOutlined style={{ fontSize: '60px' }} />
              </div>
            </div>
          </Col>
          <Col xs={24} sm={18}>
            <div>
              <div style={styles.candidateName}>
                {name || "Confidential Candidate"}
              </div>
              <div style={styles.candidateTitle}>
                {jobTitle || "Not specified"}
              </div>

              <Space direction="vertical" size={12} style={{ width: '100%' }}>
                <div style={styles.contactInfoItem}>
                  <EnvironmentOutlined style={styles.iconStyle} />
                  <span>{location}</span>
                </div>

                {phone && (
                  <div style={styles.contactInfoItem}>
                    <PhoneOutlined style={styles.iconStyle} />
                    <span>{phone}</span>
                  </div>
                )}

                {email && (
                  <div style={styles.contactInfoItem}>
                    <MailOutlined style={styles.iconStyle} />
                    <span>{email}</span>
                  </div>
                )}

                <div style={styles.contactInfoItem}>
                  <CalendarOutlined style={styles.iconStyle} />
                  <span>Updated {moment(candidate.dateModified || new Date()).format("LL")}</span>
                </div>
              </Space>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  // Extract professional summary from resume text (for v1 format)
  const extractProfessionalSummary = (resumeText) => {
    if (!resumeText) return [];

    // Enhanced regex to match more common section headings for professional summaries
    // Updated to handle multiple newlines after the heading before content begins
    const summaryRegex = /(?:PROFESSIONAL\s+SUMMARY|SUMMARY|PROFILE|PROFESSIONAL\s+PROFILE|CAREER\s+(?:SUMMARY|PROFILE|OBJECTIVE)|EXECUTIVE\s+SUMMARY|PERSONAL\s+SUMMARY|ABOUT\s+ME|OBJECTIVE)(?:\s*:|:?\s*)(?:\r?\n\s*)*?([\s\S]*?)(?=(?:\r?\n\r?\n\s*[A-Z][A-Za-z]|\r?\n\s*[A-Z][A-Z\s]+(?::|\.|\))|\r?\n\s*-{3,}|$))/i;

    const match = resumeText.match(summaryRegex);

    let summaryText = '';
    if (match && match[1] && match[1].trim().length > 10) { // Ensure we have meaningful content
      summaryText = match[1].trim();
    } else {
      // Specific pattern for "PROFESSIONAL SUMMARY:" followed by content after multiple newlines
      const exactPattern = /PROFESSIONAL\s+SUMMARY:(?:\r?\n\s*)+(.+(?:\r?\n.+)*?)(?=(?:\r?\n\r?\n\s*[A-Z]|$))/i;
      const exactMatch = resumeText.match(exactPattern);

      if (exactMatch && exactMatch[1] && exactMatch[1].trim().length > 10) {
        summaryText = exactMatch[1].trim();
      } else {
        // If still no match, try to extract the first paragraph (excluding header info)
        // Skip the first few lines which typically contain name and contact info
        const skipHeaderText = resumeText.replace(/^([^\r\n]*\r?\n){1,5}/, ''); // Skip first 1-5 lines
        const firstParagraphRegex = /^\s*([^\r\n]+(?:\r?\n[^\r\n]+){0,3})\r?\n\r?\n/;
        const firstParagraphMatch = skipHeaderText.match(firstParagraphRegex);

        if (firstParagraphMatch && firstParagraphMatch[1] &&
          firstParagraphMatch[1].length > 50 && // Must be reasonably long
          !/(?:EXPERIENCE|EDUCATION|SKILLS|EMPLOYMENT|WORK)/i.test(firstParagraphMatch[1])) { // Not another section
          summaryText = firstParagraphMatch[1].trim();
        }
      }
    }

    // Process bullet points - support multiple formats
    if (summaryText) {
      // Skip name and contact info if it was mistakenly captured
      if (/^[A-Z\s]+\r?\n.*@.*\|.*\d{3}.*\d{3}.*\d{4}/.test(summaryText)) {
        summaryText = summaryText.replace(/^[A-Z\s]+\r?\n.*@.*\|.*\d{3}.*\d{3}.*\d{4}(\r?\n\r?\n)?/, '');
      }

      // Check for common bullet point indicators
      if (/(?:\r?\n\s*[\*\-•●⦿⦾⦿○◦◆◇▪▫►▻▸▹➤➢➣➔→•])/.test(summaryText)) {
        // Split by common bullet point indicators
        return summaryText
          .split(/\r?\n\s*[\*\-•●⦿⦾⦿○◦◆◇▪▫►▻▸▹➤➢➣➔→•]+/)
          .map(item => item.trim())
          .filter(item => item.length > 10); // Filter out too short items
      } else if (summaryText.includes('*')) {
        // Handle inline asterisks
        return summaryText
          .split('*')
          .map(item => item.trim())
          .filter(item => item.length > 10);
      } else if (/\r?\n/.test(summaryText)) {
        // If there are newlines but no bullets, split by line
        const lines = summaryText
          .split(/\r?\n/)
          .map(line => line.trim())
          .filter(line => line.length > 10);

        // If we have multiple meaningful lines, return them as points
        if (lines.length > 1) {
          return lines;
        }
      }
    }

    // Return as a single item if no bullet points detected
    return summaryText ? [summaryText] : [];
  };

  const renderAdditionalInfo = () => {
    // Check if we have v1 format data
    const isV1Format = currentDetails && currentDetails.ContactName;

    if (!isV1Format || !currentDetails) {
      return null;
    }

    // Helper function to check if a field has actual content
    const hasContent = (field) => {
      if (!field) return false;
      if (Array.isArray(field) && field[0] === "") return false;
      if (Array.isArray(field) && field[0] === "0") return false;
      return true;
    };

    // Get experience in years/months
    const experienceInfo = (() => {
      if (hasContent(currentDetails.ExperienceMonths)) {
        const months = parseInt(currentDetails.ExperienceMonths[0]);
        return {
          label: "Experience",
          value: `${Math.floor(months / 12)} years ${months % 12} months`
        };
      }
      return null;
    })();

    // Build collection of fields to display
    const infoFields = [
      experienceInfo,
      hasContent(currentDetails.HomeLocation) && {
        label: "Current Location",
        value: renderLocation(candidate.locationDetails),
        icon: <EnvironmentOutlined style={styles.iconStyle} />
      },
      hasContent(currentDetails.HighestDegree) && {
        label: "Highest Degree",
        value: currentDetails.HighestDegree[0],
        icon: <BookOutlined style={styles.iconStyle} />
      },
      hasContent(currentDetails.CurrentlyEmployed) && {
        label: "Currently Employed",
        value: currentDetails.CurrentlyEmployed[0],
        icon: <BankOutlined style={styles.iconStyle} />
      },
      hasContent(currentDetails.SFWillingToRelocate) && {
        label: "Willing to Relocate",
        value: currentDetails.SFWillingToRelocate[0] === "true" ? "Yes" : "No",
        icon: <EnvironmentOutlined style={styles.iconStyle} />
      },
      hasContent(currentDetails.SecurityClearance) && {
        label: "Security Clearance",
        value: currentDetails.SecurityClearance[0],
        icon: <FileTextOutlined style={styles.iconStyle} />
      },
      hasContent(currentDetails.Status) && {
        label: "Status",
        value: currentDetails.Status[0],
        icon: <UserOutlined style={styles.iconStyle} />
      },
      hasContent(currentDetails.LastUpdated) && {
        label: "Last Updated",
        value: moment(currentDetails.LastUpdated[0]).format("LL"),
        icon: <CalendarOutlined style={styles.iconStyle} />
      },
      hasContent(currentDetails.CreatedDate) && {
        label: "Profile Created",
        value: moment(currentDetails.CreatedDate[0]).format("LL"),
        icon: <CalendarOutlined style={styles.iconStyle} />
      },
      hasContent(currentDetails.DateOfBirth) &&
      currentDetails.DateOfBirth[0] !== "1/1/1970" && {
        label: "Date of Birth",
        value: moment(currentDetails.DateOfBirth[0]).format("LL"),
        icon: <CalendarOutlined style={styles.iconStyle} />
      },
      hasContent(currentDetails.LJDesiredJobType) && {
        label: "Desired Job Type",
        value: currentDetails.LJDesiredJobType[0],
        icon: <FileTextOutlined style={styles.iconStyle} />
      }
    ].filter(Boolean); // Remove null/undefined items

    // If no fields have content, return null
    if (infoFields.length === 0) {
      return null;
    }

    return (
      <ProfileSection title="Additional Information">
        <Card style={{ borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
          <Row gutter={[16, 16]}>
            {infoFields.map((field, index) => (
              <Col xs={24} sm={12} key={index}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {field.icon || <CalendarOutlined style={styles.iconStyle} />}
                  <div>
                    <Text type="secondary" style={{ display: 'block', fontSize: '12px' }}>{field.label}</Text>
                    <Text strong>{field.value}</Text>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Card>
      </ProfileSection>
    );
  };

  const renderExperience = () => {
    // Check if we have v1 format data
    const isV1Format = currentDetails && currentDetails.ContactName;

    let experienceItems = [];

    if (isV1Format && currentDetails.WorkHistory &&
      currentDetails.WorkHistory[0] &&
      currentDetails.WorkHistory[0].ExtCompany) {
      // V1 format - extract work history
      experienceItems = currentDetails.WorkHistory[0].ExtCompany.map((job, index) => ({
        title: job.JobTitle?.[0] || 'No Title',
        company: job.CompanyName?.[0] || 'No Organization',
        // Keep these properties for backward compatibility, but they might be null
        startDate: job.StartDate?.[0],
        endDate: job.EndDate?.[0],
        isCurrent: job.IsCurrent?.[0] === 'true',
        // This is the formatted tenure string we'll use directly
        tenure: job.Tenure?.[0],
        description: job.Description?.[0]
      }));
    } else if (currentDetails?.employees) {
      // V2 format - use employees array
      experienceItems = currentDetails.employees.map((job) => ({
        title: job.designation || 'No Title',
        company: job.organization || 'No Organization',
        startDate: job.work_since_from_month && job.work_since_from_year
          ? `${job.work_since_from_month}/${job.work_since_from_year}`
          : null,
        endDate: !job.is_current_company && job.work_since_to_month && job.work_since_to_year
          ? `${job.work_since_to_month}/${job.work_since_to_year}`
          : null,
        isCurrent: job.is_current_company,
        description: job.description
      }));
    } else if (candidate.currentPosition) {
      // Fallback to basic candidate information
      experienceItems = [{
        title: candidate.currentPosition.title,
        company: candidate.currentPosition.company,
        isCurrent: true
      }];
    }

    return (
      <ProfileSection title="Experience">
        {experienceItems.length > 0 ? (
          experienceItems.map((job, index) => (
            <WorkHistoryItem
              key={index}
              company={job.company}
              title={job.title}
              tenure={
                // If we have a pre-formatted tenure string, use it directly
                job.tenure ||
                // Otherwise try to construct from start/end dates 
                (job.startDate
                  ? (job.startDate + ' - ' + (job.isCurrent ? "Present" : (job.endDate || "End date not specified")))
                  : 'Dates not specified')
              }
            />
          ))
        ) : (
          <Empty description="No experience information available" />
        )}
      </ProfileSection>
    );
  };

  const renderEducation = () => {
    // Check if we have v1 format data
    const isV1Format = currentDetails && currentDetails.ContactName;

    let educationItems = [];

    if (isV1Format && currentDetails.EducationHistory &&
      currentDetails.EducationHistory[0] &&
      currentDetails.EducationHistory[0].ExtSchool) {
      // V1 format - extract education history
      educationItems = currentDetails.EducationHistory[0].ExtSchool.map((edu, index) => ({
        school: edu.SchoolName?.[0] || 'Not specified',
        degree: edu.Degree?.[0] || 'Not specified',
        major: edu.Major?.[0],
        startYear: edu.StartDate?.[0]?.replace(/^1/, ''), // Remove leading '1' from year 
        endYear: edu.GraduationDate?.[0]?.replace(/^1/, ''), // Remove leading '1' from year
      }));
    } else if (currentDetails?.candidate_qualifications) {
      // V2 format - use candidate_qualifications array
      educationItems = currentDetails.candidate_qualifications.map((edu) => ({
        school: edu.institution || 'Not specified',
        degree: edu.degree || 'Not specified',
        major: edu.field_of_study,
        startYear: edu.start_year,
        endYear: edu.end_year
      }));
    }

    return (
      <ProfileSection title="Education">
        {educationItems.length > 0 ? (
          educationItems.map((edu, index) => (
            <EducationItem
              key={index}
              school={edu.school}
              degree={edu.degree}
              major={edu.major}
              graduationDate={
                edu.startYear
                  ? (edu.startYear + (edu.endYear ? ' - ' + edu.endYear : ''))
                  : (edu.endYear ? edu.endYear : 'Present')
              }
            />
          ))
        ) : (
          <Empty description="No education information available" />
        )}
      </ProfileSection>
    );
  };

  const renderSkills = () => {
    // Check if we have v1 format data
    const isV1Format = currentDetails && currentDetails.ContactName;

    let skillItems = [];

    if (isV1Format && currentDetails.Interests &&
      currentDetails.Interests[0] &&
      currentDetails.Interests[0].ExtInterest) {
      // V1 format - extract skills as interests
      skillItems = currentDetails.Interests[0].ExtInterest.map(interest =>
        interest.Interest?.[0] || ''
      ).filter(skill => skill !== '');
    } else if (currentDetails?.candidate_it_skills) {
      // V2 format - use candidate_it_skills array
      skillItems = currentDetails.candidate_it_skills.map(skill =>
        skill.skill_name || ''
      ).filter(skill => skill !== '');
    }

    return (
      <ProfileSection title="Skills">
        <Card style={{ borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {skillItems.length > 0 ? (
              skillItems.map((skill, index) => {
                // Determine tag color based on skill category (similar to v1)
                let tagColor = 'green'; // Default to green instead of blue
                const skillText = typeof skill === 'string' ? skill.toLowerCase() : '';

                if (skillText.includes('java') || skillText.includes('spring') || skillText.includes('hibernate')) {
                  tagColor = 'cyan'; // Java ecosystem
                } else if (skillText.includes('react') || skillText.includes('angular') || skillText.includes('vue') ||
                  skillText.includes('javascript') || skillText.includes('node') || skillText.includes('html') ||
                  skillText.includes('css')) {
                  tagColor = 'green'; // Frontend/JS ecosystem
                } else if (skillText.includes('aws') || skillText.includes('cloud') || skillText.includes('docker') ||
                  skillText.includes('kubernetes') || skillText.includes('devops')) {
                  tagColor = 'volcano'; // Cloud/DevOps
                } else if (skillText.includes('sql') || skillText.includes('database') || skillText.includes('oracle') ||
                  skillText.includes('mysql') || skillText.includes('mongo')) {
                  tagColor = 'purple'; // Databases
                } else if (skillText.includes('agile') || skillText.includes('scrum') || skillText.includes('jira') ||
                  skillText.includes('management')) {
                  tagColor = 'orange'; // Process/Management
                }

                return (
                  <Tag
                    key={index}
                    color={tagColor}
                    style={{
                      padding: '6px 10px',
                      borderRadius: '16px',
                      fontSize: '13px',
                      margin: '4px'
                    }}
                  >
                    {skill}
                  </Tag>
                );
              })
            ) : (
              <Empty description="No skills information available" />
            )}
          </div>
        </Card>
      </ProfileSection>
    );
  };

  const renderResume = () => {
    // Check if we have v1 format data
    const isV1Format = currentDetails && currentDetails.ContactName;

    if (isV1Format) {
      // V1 format

      // Check if we have a PDF (base64 encoded)
      if (currentDetails.ResumeHTML?.[0]?.startsWith('JVBERi0')) {
        // This is a base64 encoded PDF
        const pdfData = currentDetails.ResumeHTML[0];
        const pdfUrl = `data:application/pdf;base64,${pdfData}`;

        return (
          <div style={{ height: "calc(100vh - 200px)" }}>
            <object
              data={pdfUrl}
              type="application/pdf"
              width="100%"
              height="100%"
              style={{ border: 'none' }}
            >
              <iframe
                src={pdfUrl}
                width="100%"
                height="100%"
                style={{ border: 'none' }}
              >
                <div style={{ padding: '20px', textAlign: 'center' }}>
                  <Text>Your browser does not support PDFs.</Text>
                  <br />
                  <Button
                    type="primary"
                    icon={<DownloadOutlined />}
                    href={pdfUrl}
                    download="resume.pdf"
                    style={{ marginTop: '12px' }}
                  >
                    Download PDF
                  </Button>
                </div>
              </iframe>
            </object>
          </div>
        );
      }

      // If it's HTML content
      if (currentDetails.ResumeHTML?.[0]) {
        const cleanHtml = currentDetails.ResumeHTML[0]
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&amp;/g, '&')
          .replace(/&quot;/g, '"')
          .replace(/&#39;/g, "'")
          .replace(/&nbsp;/g, ' ');

        return (
          <div style={{ height: "calc(100vh - 200px)", overflow: "auto" }}>
            <Card
              style={{
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
              }}
            >
              <div
                style={{ padding: "20px", backgroundColor: "#fff", border: "1px solid #f0f0f0" }}
                dangerouslySetInnerHTML={{ __html: cleanHtml }}
                className="resume-content"
              />
            </Card>
          </div>
        );
      }

      // Fallback to text content
      if (currentDetails.ResumeText?.[0]) {
        return (
          <div style={{ height: "calc(100vh - 200px)", overflow: "auto" }}>
            <pre style={{
              padding: "20px",
              backgroundColor: "#fff",
              border: "1px solid #f0f0f0",
              whiteSpace: "pre-wrap",
              fontFamily: "monospace",
              fontSize: "14px"
            }}>
              {currentDetails.ResumeText[0]}
            </pre>
          </div>
        );
      }

      return <Empty description="Resume not available" />;

    } else {

      if (currentDetails?.attachments) {
        return (
          <div style={{ height: "calc(100vh - 200px)" }}>
            <DocViewer
              documents={[{ uri: `${process.env.REACT_APP_BASE_URL}${currentDetails.attachments}` }]}
              pluginRenderers={DocViewerRenderers}
              style={{ height: "100%", width: "100%" }}
            />
          </div>
        );
      } else {
        return <Empty description="Resume not available" />;
      }
    }
  };

  const renderNotes = () => {
    if (!candidateDbId) {
      return (
        <Card title="Notes" style={styles.section}>
          <Empty
            description={
              <span>
                {isLoading
                  ? "Loading candidate details..."
                  : "Candidate not found in database. Notes cannot be accessed."}
              </span>
            }
          />
        </Card>
      )
    }

    return (
      <Card title="Notes" style={styles.section}>
        <Notes
          handleCancel={() => { }} // Empty function since we don't need to hide notes in non-modal mode
          isVisible={true} // Always show notes in the tab
          handleNotes={handleNotes}
          notes={notesData}
          getNotes={() => { }} // No need to fetch notes as we already have them
          jobOpenings={{ _id: candidateDbId, ...selectedRow }}
          user={users}
          updateNoteState={() => { }} // No need to update visibility in non-modal mode
          handleUpdateNote={handleUpdateNotes}
          handleDeleteNote={handleDeleteNotes}
          notesField={"multipleNotes"}
          isModal={false}
        />
      </Card>
    )
  }

  if (currentError) {
    return <Empty description={`Error: ${currentError}`} />
  }

  return (
    <Layout style={styles.container} className={cssStyles.cbContainer}>
      {renderHeader()}

      <Content style={styles.content}>
        <div style={styles.tabsContainer}>
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            tabBarStyle={{
              color: '#52c41a',
              fontWeight: 'normal',
              marginBottom: 0
            }}
            tabBarGutter={48}
          >
            <TabPane
              tab={
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <UserOutlined style={{ marginRight: '8px' }} />
                  Profile
                </span>
              }
              key="profile"
            />
            <TabPane
              tab={
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <FileTextOutlined style={{ marginRight: '8px' }} />
                  Resume
                </span>
              }
              key="resume"
            />
            <TabPane
              tab={
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <EditOutlined style={{ marginRight: '8px' }} />
                  Notes {" "} <Badge style={{ marginLeft: '4px' }} count={notesData?.data?.data?.multipleNotes?.length || 0} />
                </span>
              }
              key="notes"
            />
          </Tabs>
        </div>

        <div style={{ marginTop: '24px' }}>
          {activeTab === "profile" && (
            <>
              {renderBasicInfo()}
              {isLoading ? (
                <Skeleton active paragraph={{ rows: 10 }} />
              ) : (
                <>
                  {/* Professional Summary Section - only show once */}
                  {currentDetails?.ResumeText?.[0] && (
                    <>
                      <ProfileSection title="Professional Summary">
                        <Card style={styles.summaryCard}>
                          <div style={{ padding: '8px' }}>
                            {extractProfessionalSummary(currentDetails.ResumeText[0]).map((item, index) => (
                              <div
                                key={index}
                                style={{
                                  marginBottom: '12px',
                                  display: 'flex',
                                  alignItems: 'flex-start'
                                }}
                              >
                                <div style={styles.bulletPoint}>•</div>
                                <Text style={{
                                  lineHeight: '1.6',
                                  fontSize: '14px',
                                  display: 'block',
                                  color: '#333'
                                }}>
                                  {item}
                                </Text>
                              </div>
                            ))}
                          </div>
                        </Card>
                      </ProfileSection>
                      <Divider style={{ margin: '16px 0' }} />
                    </>
                  )}

                  {renderAdditionalInfo()}
                  {renderExperience()}
                  {renderEducation()}
                  {renderSkills()}
                </>
              )}
            </>
          )}

          {activeTab === "resume" && (
            <>
              {isLoading ? <Skeleton active paragraph={{ rows: 10 }} /> : renderResume()}
            </>
          )}

          {activeTab === "notes" && (
            <>
              {isLoading ? <Skeleton active paragraph={{ rows: 10 }} /> : renderNotes()}
            </>
          )}
        </div>
      </Content>
    </Layout>
  )
}

// Add CSS class for resume content styling
const resumeStyles = `
.resume-content div {
  position: static !important;
  margin-bottom: 8px;
}

.resume-content {
  font-family: 'Calibri, Arial, sans-serif';
  line-height: 1.5;
}

.resume-content b {
  font-weight: 600;
}

.viewed-tag {
  background-color: #f6ffed !important;
  border-color: #b7eb8f !important;
  color: #52c41a !important;
}

.ant-tabs-ink-bar {
  background-color: #52c41a !important;
  height: 3px !important;
}

.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #52c41a !important;
  font-weight: 500 !important;
}

.ant-tabs-tab:hover {
  color: #52c41a !important;
}
`;

export default CandidateDetailView

